import OAUTH_API_V2 from 'api/oauth/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'

function* fetchAppData({
  payload,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    const { response, error } = yield call(
      OAUTH_API_V2.fetchClientInfo,
      payload,
    )
    if (error) {
      throw error
    }

    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form,
        delay: 10000,
      }),
    )

    reject(error)
  }
}

function* tryAuthenticate({
  payload,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    const { response, error } = yield call(
      OAUTH_API_V2.tryAuthenticate,
      payload,
    )
    if (error) {
      throw error
    }

    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form,
        delay: 10000,
      }),
    )
    reject(error)
  }
}

export default function* Sagas() {
  yield takeLatest('OAUTH/FETCH_APP_DATA', fetchAppData)
  yield takeLatest('OAUTH/TRY_AUTHENTICATE', tryAuthenticate)
}
